import { z } from "zod";

export const TaskVisibleFieldsSchema = z.object({
  repeat: z.boolean(),
  notes: z.boolean(),
  log: z.boolean(),
});

export type TaskVisibleFields = z.infer<typeof TaskVisibleFieldsSchema>;

export const DEFAULT_TASK_VISIBLE_FIELDS: TaskVisibleFields = {
  repeat: false,
  notes: false,
  log: false,
};

export function normalizeTaskVisibleFields(value: unknown): TaskVisibleFields {
  const parsed = TaskVisibleFieldsSchema.partial().safeParse(value);
  return parsed.success
    ? { ...DEFAULT_TASK_VISIBLE_FIELDS, ...parsed.data }
    : { ...DEFAULT_TASK_VISIBLE_FIELDS };
}
